module.exports = __webpack_public_path__ + "static/media/9_I wish you enough_EN.bccfa263.txt";